/**
 * A search configuration created from a search config XML file by HisSearchService.loadSearchConfiguration()
 */
export class HisSearchConfiguration {
    configFile: string;
    name: string;
    pageTitle: string;
    tableTitle: string;
    searchCriteria: HisSearchConfigurationCriteria;

    /**
     * Return the criterion with the given path. It seems that the method must be static if 'config'
     * has not been created via a formal constructor (but e.g. by JSON converters).
     *
     * @param config the search configuration
     * @param path the path of the search criterion to look up
     */
    public static getSearchCriterion(config: HisSearchConfiguration, path: string): HisSearchConfigurationCriterion {
        for (let group of config.searchCriteria.group ) {
            for (let criterion of group.criteria) {
                if (criterion.path === path) {
                    return criterion;
                }
            }
        }
        return null; // not found
    }

    public static getGroup(config: HisSearchConfiguration, path: string): HisSearchConfigurationGroup {
        for (let group of config.searchCriteria.group ) {
            for (let criterion of group.criteria) {
                if (criterion.path === path) {
                    return group;
                }
            }
        }
        return null; // not found
    }
}

export class HisSearchConfigurationCriteria {
    group: HisSearchConfigurationGroup[];
    quickSearchCriteria?: boolean;
}

/** a fieldset inside a search configuration */
export class HisSearchConfigurationGroup {
    label: string;
    helptext?: string;
    criteria: HisSearchConfigurationCriterion[];
    quickSearchGroup?: boolean;
    criteriaGroup?: boolean;
}

/** a search criterion inside a group */
export class HisSearchConfigurationCriterion {
    // general options
    label: string;
    helptext?: string;
    path: string;
    inputType?: string;
    quickSearchCriterion?: boolean;
    value?: string;
    defaultValue?: string;
    // Pflichtfeld?
    required ?= false;

    // autocomplete options
    selectFrom?: string;
    multipleSelect?: boolean;
    // show "(nicht gefüllt)" entry in dropdowns etc. ?
    showNullItem ?= true;
    // icon zum Öffnen des autocomplete-dropdowns anzeigen?
    showDropdownIcon?: boolean;
    typeaheadMinLength?: number;
    typeaheadMaxResults?: number;

    // Gleich- Ungleich Operatoren anzeigen
    showUnequalOption?: boolean;
    // Suche soll mit NOT-Operator ausgeführt werden (z. B. Suchset laden und suchen)
    // Der Suchpfad sieht dann so aus: searchCriteriaExt>Person.gender.id(NOT)=true
    not?: boolean;

    // tree-select options
    treeName?: string;
    selectFromTree?: string; // URL of a REST-API that returns the tree data

    // search-select options
    searchEntity?: string; // name of the entity whose data is selectable in the autocomplete field
    searchConfigFile?: string; // sub-search configuration file
    showSearchFilter?= true;
    
    multiSearchCriterion?: boolean;
    multiSearchCriterionLabels?: string;
    placeholder?: string;
}

